// Buy-phase helpers: budget math, validation, and bot fill for empty slots.
import { BUDGET, STARTING_LOADOUT, WEAPON_COST, GRENADE_COST, SMOKE_COST, MEDKIT_COST, FLASH_COST, ARMOR, loadoutCost, demoTeam } from '@cs-shot/battle-sim';
import type { ArmorType, Loadout, WeaponClass } from '@cs-shot/battle-sim';

export const TOTAL_BUDGET = BUDGET;

export const ARMOR_ORDER: ArmorType[] = ['none', 'light', 'heavy'];
export const WEAPON_ORDER: WeaponClass[] = ['rifle', 'awp', 'lmg'];

export function emptyLoadout(): Loadout {
  return { ...STARTING_LOADOUT };
}

export function cost(l: Loadout): number {
  return loadoutCost(l);
}
export function remaining(l: Loadout): number {
  return TOTAL_BUDGET - cost(l);
}
export function isValid(l: Loadout): boolean {
  return cost(l) <= TOTAL_BUDGET;
}
export function armorCost(a: ArmorType): number {
  return ARMOR[a].cost;
}

/** Can a field be set to a value without busting the budget? */
export function canSetWeapon(l: Loadout, weapon: WeaponClass): boolean {
  return cost({ ...l, weapon }) <= TOTAL_BUDGET;
}
export function canSetArmor(l: Loadout, armor: ArmorType): boolean {
  return cost({ ...l, armor }) <= TOTAL_BUDGET;
}
export function canTakeGrenade(l: Loadout): boolean {
  return l.grenade || cost({ ...l, grenade: true }) <= TOTAL_BUDGET;
}
export function canTakeMedkit(l: Loadout): boolean {
  return l.medkit || cost({ ...l, medkit: true }) <= TOTAL_BUDGET;
}
export function canTakeSmoke(l: Loadout): boolean {
  return l.smoke || cost({ ...l, smoke: true }) <= TOTAL_BUDGET;
}
export function canTakeFlash(l: Loadout): boolean {
  return l.flash || cost({ ...l, flash: true }) <= TOTAL_BUDGET;
}

export { WEAPON_COST, GRENADE_COST, SMOKE_COST, MEDKIT_COST, FLASH_COST, ARMOR, demoTeam };
